import { createSelector } from '@reduxjs/toolkit'

const getArcAdvertisersState = (state) => state.arcAdvertisers

export const getArcAdvertisers = createSelector(
  getArcAdvertisersState,
  (state) => {
    return state.sortedIds.map((id) => state.entities[id])
  }
)

export const getArcAdvertiserById = createSelector(
  getArcAdvertisersState,
  (state) => (id) => state.entities[id]
)

export const getSelectedAdvertiser = createSelector(
  getArcAdvertisersState,
  (state) => state.selectedAdvertiser
)

export const getIsLoaded = createSelector(
  getArcAdvertisersState,
  (state) => state.isLoaded
)

export const getIsSavingActive = createSelector(
  getArcAdvertisersState,
  (state) => state.isSavingActive
)

export const getPage = createSelector(
  getArcAdvertisersState,
  (state) => state.page
)

export const getPageCount = createSelector(
  getArcAdvertisersState,
  (state) => state.pageCount
)

export const getSearchString = createSelector(
  getArcAdvertisersState,
  (state) => state.search
)

export const getFilters = createSelector(
  getArcAdvertisersState,
  (state) => state.filters
)

export const getSorter = createSelector(
  getArcAdvertisersState,
  (state) => state.sorter
)

export const getIsDataFilteredOrSorted = createSelector(
  [getFilters, getSorter, getSearchString],
  (filters, sorter, search) => {
    return !!(
      Object.keys(filters).length ||
      Object.keys(sorter).length ||
      search
    )
  }
)